import {Box, Divider, Link, Typography} from "@mui/material";
import {faCalendar} from "@fortawesome/pro-duotone-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {simpleDateFormatter} from "@/src/utils/dateFormatter";
import BorderGradientBox from "@/src/components/common/border-gradient-box/border-gradient-box";
import Image from "next/image";
import NextLink from "next/link";
import ReactHtmlParser from "react-html-parser";
import SpanTypography from "@/src/mui-custom/typography/span-typography/span-typography";
import type {Post} from "@/src/_types/Post/post";

const PostItem = (
    {
        post,
        journalUrl
    }: {
        post: Post;
        journalUrl: string;
    }
) => (
    <Box
        display="flex"
        flexWrap="wrap"
        alignItems="flex-start"
        maxWidth={{lg: '60%'}}
        gap={{xs: .25, sm: .25, md: 1.5}}
        sx={{
            flexDirection: {xs: 'column', md: 'row'}
        }}
    >
        {
            post.image_url && (
                <Box
                    mb={{xs: 0, sm: 0, md: 1.5}}
                    sx={{
                        flexShrink: 0,
                        marginBottom: .5,
                        maxWidth: {xs: 'auto', sm: 'auto', md: '12.5rem'},
                        width: {xs: '100%'}
                    }}
                >
                    <Link
                        component={NextLink}
                        href={`/${journalUrl}posts/${post.slug}`}
                        display="block"
                    >
                        <BorderGradientBox size={5}>
                            <Image
                                src={post.image_url}
                                alt={post.image_alt || post.title}
                                width={250}
                                height={250}
                                title={post.title}
                                style={{
                                    width: '100%',
                                    height: 'auto'
                                }}
                            />
                        </BorderGradientBox>
                    </Link>
                </Box>
            )
        }
        <Box
            sx={{
                flex: 1,
            }}
        >
            <Typography
                variant="subtitle1"
                sx={{
                    color: 'custom.brown',
                    fontSize: '.8rem',
                }}
            >
                {
                    post.subtitle
                }
            </Typography>
            <Link
                component={NextLink}
                href={`/${journalUrl}posts/${post.slug}`}
            >
                <Typography
                    component="h3"
                    fontSize={'1.25rem'}
                >
                    {
                        post.title
                    }
                </Typography>
            </Link>
            <Divider
                sx={{
                    my: .25,
                    opacity: .5,
                    borderColor: 'custom.dividerBorderColor'
                }}
            />
            <Box
                display="flex"
                alignItems="center"
            >
                <SpanTypography
                    color="success.main"
                    mr={.25}
                    fontSize={'.8rem'}
                    sx={{lineHeight: 0}}
                >
                    <FontAwesomeIcon
                        icon={faCalendar}
                    />
                </SpanTypography>
                <SpanTypography
                    fontSize={'.8rem'}
                    variant="body2"
                >
                    {
                        simpleDateFormatter(post.publish_date)
                    }
                </SpanTypography>
            </Box>
            <Divider
                sx={{
                    mt: .25,
                    opacity: .5,
                    borderColor: 'custom.dividerBorderColor'
                }}
            />
            <Box
                component="section"
                role="abstract"
                sx={{
                    fontSize: '.875rem',
                }}
            >
                <Typography
                    py={0}
                    component="div"
                    variant="body1"
                    fontSize={'.8rem'}
                >
                    {
                        ReactHtmlParser(
                            post.abstract
                        )
                    }
                </Typography>
            </Box>
        </Box>
    </Box>
)

export default PostItem;